import { parseProductShareLink } from '@/apis/goods'
import { useUserStore } from '@/stores'
import reg from '@/utils/reg'
import { saveLocalSearchImg } from '@/utils/searchImg'
import { reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export const parseUrlQuery = (url) => {
  const query = {}

  const { pathname, origin, searchParams } = new URL(url)
  if (searchParams.get('url')) {
    const isMatch = parseUrlQuery(decodeURIComponent(searchParams.get('url')))
    if (isMatch) {
      return isMatch
    } else {
      searchParams.delete('url')
      return parseUrlQuery(url)
    }
  }
  if (origin.includes('weidian.com')) {
    // 微店
    query.id = searchParams.get('itemID') || searchParams.get('itemId')
    query.source = 'WD'
  } else if (origin.includes('tmall.com')) {
    query.id = searchParams.get('id')
    query.source = 'TB'
  } else if (origin.includes('taobao.com')) {
    query.id = searchParams.get('id')
    query.source = 'TB'
  } else if (origin.includes('1688.com')) {
    const idStartIndex = pathname.lastIndexOf('/') + 1
    const idEndIndex = pathname.lastIndexOf('.html')
    const id = pathname.slice(idStartIndex, idEndIndex)
    query.id = id
    query.source = 'AL'
  } else {
    return false
  }
  if (!reg.nonNum.test(query.id)) {
    return false
  }
  return query
}
export const useSearch = () => {
  const $router = useRouter()
  const $route = useRoute()
  const userStore = useUserStore()
  const state = reactive({
    searchForm: {
      search: $route.query['key-word'],
      searchType: 'product',
    },
    loading: false,
    uploadLoading: false,
    searchType: 'product',
    searchHolder: null,
    hotWorldsVisible: false,
    historyList: [],
    hotList: [],
    deleteStatus: false,
  })
  // 解析搜索URL
  const parseSearchUrl = async (url) => {
    const query = {}
    try {
      const { pathname, origin, searchParams } = new URL(url)
      if (searchParams.get('url')) {
        const isMatch = parseSearchUrl(decodeURIComponent(searchParams.get('url')))
        if (isMatch) {
          return isMatch
        } else {
          searchParams.delete('url')
          return parseSearchUrl(url)
        }
      }
      if (origin.includes('weidian.com')) {
        // 微店
        query.id = searchParams.get('itemID') || searchParams.get('itemId')
        query.source = 'WD'
      } else if (origin.includes('tmall.com')) {
        query.id = searchParams.get('id')
        query.source = 'TB'
      } else if (origin.includes('taobao.com')) {
        query.id = searchParams.get('id')
        query.source = 'TB'
      } else if (origin.includes('1688.com')) {
        const idStartIndex = pathname.lastIndexOf('/') + 1
        const idEndIndex = pathname.lastIndexOf('.html')
        const id = pathname.slice(idStartIndex, idEndIndex)
        query.id = id
        query.source = 'AL'
      } else {
        throw new Error()
      }
      if (!reg.nonNum.test(query.id)) {
        throw new Error()
      }
      const routeParams = { name: 'product', query }
      if ($route.name === 'product') {
        delete routeParams.name
      }
      $router.push(routeParams)
    } catch (error) {
      try {
        const res = await parseProductShareLink({ content: url })
        const routeParams = {
          name: 'product',
          query: {
            source: res.source,
            id: res.thirdGoodsId,
          },
        }
        if ($route.name === 'product') {
          delete routeParams.name
        }
        $router.push(routeParams)
      } catch (error) {
        $router.push({ name: 'uni-order', query: { url: encodeURIComponent(url) } })
      }
    }
  }

  const base64ImgToSearch = async ({ imageId, url, imageId2 }) => {
    const query = {
      searchType: 'picture',
      imageId,
      imageId2,
    }
    state.uploadLoading = true
    try {
      await saveLocalSearchImg(url)

      state.uploadLoading = false
      state.searchForm.search = null
      const pathParams = {
        name: 'search-list',
        query: query,
      }
      if ($route.path === '/search-list') {
        delete pathParams.name
      }
      $router.push(pathParams)
    } catch (err) {
      state.uploadLoading = false
    }
  }
  // 搜索事件
  const searchHandle = async () => {
    if (userStore.profile.userId === 213303620) {
      console.log('213303620')
      window.gtag('event', 'purchase', {
        transaction_id: `test-${Date.now()}`, // 必填，订单唯一ID
        value: 111, // 订单总金额
        currency: 'CNY',
        send_to: 'G-KWYFYH5B8P',
      })
    }
    let { search } = state.searchForm
    if (!search) return
    if (search.includes('http')) {
      // 为网址
      parseSearchUrl(search)
    } else {
      const pathParams = {
        path: '/search-list',
        query: { 'key-word': search, searchType: 'key' },
      }
      if ($route.path === '/search-list') {
        // 已在搜索页
        delete pathParams.path
      }
      $router.push(pathParams)
    }
  }
  const handleChange = (value) => {
    state.searchForm.search = value.replace(/^\s+|\s+$/g, '')
  }
  return {
    state,
    parseSearchUrl,
    base64ImgToSearch,
    searchHandle,
    handleChange,
  }
}
